
import { Component as ReactComponent } from 'react';
/**
 * 组件实例定义
 */
export type IPublicTypeComponentInstance = Element | ReactComponent<any> | object;